import React, { useState, useEffect } from 'react';
import { t } from '@insight/toolkit-utils'
import {
    Modal,
    Icon
  } from '../index'

const marketoScriptId = 'mktoForms';
const formId = '2682'
const formName = 'eCommerce-Leasing-Offers-Contact-Us-2682 [en_US] (2682)'

export default function ShortTermLeasingFormModal({
    materialId,
    setIsMarketoForm,
    onClose
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoadError, setIsLoadError] = useState(false)

  useEffect(() => {
    if (!document.getElementById(marketoScriptId) || !window?.MktoForms2) {
      loadScript();
    } else {
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    isLoaded && window?.MktoForms2?.loadForm("//page.insight.com", "835-ZTL-687", 2682, ()=>formHandler(materialId));
  }, [isLoaded, formId, materialId]);

  const formHandler = (materialId) => {
    /* Capturing Impression of formInteraction with fireTagEvent */
    MktoForms2.onFormRender(function(form){
      fireTagEvent("form",{
        formName,
        formId,
        materialId,
        formPlacement:"onpage",
        formInteraction:"Impression"
      });
    });

    MktoForms2.whenRendered(function (form) {
      var isInitialized = false;
      var fireInitialized = function(e) {
        if (!isInitialized) {
          isInitialized = true;
          form.vals({"sku": materialId});
          form.addHiddenFields({"refcode": "Apple finance and leasing services contact us"});
          fireTagEvent("form",{
            formName,
            formId,
            materialId,
            formPlacement:"onpage",
            formInteraction:"Initiation"
          });
        }
      }
      document.getElementById("mktoForm_2682")?.addEventListener("click", fireInitialized);

      /* Check the email ID validation */
      const checkEmail = function (email) {
      const emailBlacklist = [
          /@hotmail\./gi,
          /@gmail\./gi,
          /@aol\./gi,
          /@live\./gi,
          /@icloud\./gi,
          /@comcast\./gi,
          /@att\./gi,
          /@verizon\./gi,
          /@sprintmail\./gi,
          /@msn\./gi,
          /@sbcglobal\./gi,
          /@yahoo\./gi,
          /@sap\./gi,
          /@null\./gi
        ]

        for (var i = 0; i < emailBlacklist.length; i++) {
          if (email.match(emailBlacklist[i])) {
            return false;
          }
        }

        return true;
      }

      var formId = form.getId();
        // Add custom form validation
      form.onValidate(function (isValid){
        if (!isValid) return;
        const errorMessage = "Please enter your business email"
        const emailField =  document.querySelectorAll('#mktoForm_2682 #Email');
        const emailFiledElement = emailField?.[0]
        emailField.after = function(ele) {
          emailFiledElement.insertAdjacentElement('afterend', ele[0])
        }
        emailField.attr = function(name, value){
          emailFiledElement && emailFiledElement.setAttribute(name, value)
        }
        emailField.outerWidth = function () {
          return emailFiledElement.offsetWidth
        }

        const emailFieldVal = emailField?.[0]?.value
        if(emailFieldVal){
          if (checkEmail(emailFieldVal)){
            form.submittable(true);
          } else {
            form.submittable(false)
            form.showErrorMessage(errorMessage, emailField);
          }
        }
      });
      form.onSuccess(function(values, followUpUrl) {
        try {
          var formPlacement = "modal";
          fireTagEvent("form", {
            formName,
            formId,
            materialId,
            formPlacement: formPlacement,
            formInteraction: "Submission"
          })
          window["_satellite"] && _satellite.track && _satellite.track("form");
          location.href = window.location.origin + "/en_US/about/contact-us/confirmation" + '.html';
          return false;
        } catch (error) {
          console.error(error);
          handleRedirect();
        }
      });
      function handleRedirect() {
        const confirmationURL = "/content/insight-web/en_US/about/contact-us/confirmation";
        let redirectPath = window.location.origin + confirmationURL;
        if (!redirectPath.endsWith('.html')) {
          redirectPath += '.html';
        }
        location.href = redirectPath;
        return false;
      }
    });
  }

  const loadScript = () => {
    var s = document.createElement('script');
    s.id = marketoScriptId;
    s.type = 'text/javascript';
    s.async = true;
    s.src='//page.insight.com/js/forms2/js/forms2.min.js';
    s.onload = () => {
      setIsLoaded(true)
      setIsLoadError(false)
    }
    s.onerror = () => {
      setIsLoadError(true)
      setIsLoaded(false)
    }
    document.getElementsByTagName('head')[0].appendChild(s);
  };

  const handleClick = () => {
    setIsMarketoForm(false)
  }

  return (
    <Modal
        isOpen={true}
        size="medium"
        onClose={onClose}
        closeOnOutsideClick={true}
    >
    <div className="c-short-term-leasing__form">
        <Modal.Header
          className="o-grid--center"
          onClick={onClose}
        >
            <div onClick={handleClick} className='o-grid o-grid--center'>
                <Icon
                    type="error"
                    title="go back"
                    icon="arrow-left"
                />
                {t('Back')}
            </div>
        </Modal.Header>
        <div className="c-short-term-leasing__form-gradient"></div>
        <Modal.Body
            id="short-term-leasing-from-modal"
            data-testid="short-term-leasing-from-modal"
        >
          {isLoadError?
            <div>{t('The form failed to load. Please refresh the page or try again later.')}</div>:
            <>
              <div className="c-modal__content-header">{t('Leasing inquiry form')}</div>
              <div className="c-modal__content-content">{t('The product will be forwarded along with your leasing inquiry. An Insight specialist will contact you within 48 business hours.')}</div>
              <form id='mktoForm_2682'></form>
            </>
          }
        </Modal.Body>
    </div>
    </Modal>
  );
}